import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import kf1 from "../../Images/KorigadFort/kf1.jpg";
import kf2 from "../../Images/KorigadFort/kf2.jpg";
import kf3 from "../../Images/KorigadFort/kf3.jpg";
import kf4 from "../../Images/KorigadFort/kf4.jpg";
import kf5 from "../../Images/KorigadFort/kf5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Ghangad Fort Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      { time: "07:30 AM", activity: "on the way." },
      {
        time: "08:30 AM",
        activity: "Reach the base village and take a short trek briefing.",
      },
      {
        time: "08:45 AM",
        activity: "Begin the Ghangad Fort Trek through lush forest paths.",
      },
      {
        time: "03:00 PM",
        activity: "Return to the base village and enjoy lunch.",
      },
      { time: "05:00 PM", activity: "Start the return journey to Pune." },
      { time: "10:00 PM", activity: "Approx. arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Ghangad Fort offers a rewarding trek with historic fort ruins, sweeping valley views, and a crisp monsoon atmosphere.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏞️ Entry & Local Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Ghangad Fort Trail", image: kf1 },
      { title: "Historic Fort Ruins", image: kf2 },
      { title: "Valley Panorama", image: kf3 },
      { title: "Forest Path", image: kf4 },
      { title: "Monsoon Viewpoint", image: kf5 },
    ],
    trekData: [
      {
        name: "Ghangad Fort Trek",
        image: kf1,
        info: "The Ghangad Fort Trek is a scenic Sahyadri adventure that takes trekkers through dense forest stretches and opens up to a historic fort plateau with expansive valley views. This itinerary is designed for early risers who enjoy a morning trail, a relaxed lunch break, and a refreshing afternoon stop at Savlya Ghat before heading back to Pune.",
      },
    ],
    faq: [
      {
        question: "What is special about Ghangad Fort?",
        answer:
          "Ghangad Fort is known for its scenic ridgeline, peaceful surroundings, and beautiful views of the surrounding valleys.",
      },
      {
        question: "Is the trek suitable for beginners?",
        answer:
          "Yes, the trek is beginner-friendly with a steady climb and manageable terrain for hikers with basic fitness.",
      },
      {
        question: "What should I carry?",
        answer:
          "Carry a backpack, water bottle, trekking shoes, rain cover, extra clothes, and personal medicines.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes, breakfast, lunch, and evening tea are included in this package.",
      },
    ],
  },
];

const GhangadFort = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Ghangad Fort Trek"
          location="Ghangad Fort & Savlya Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default GhangadFort;
